module.exports = __webpack_public_path__ + "media/images/user-logo-7fcb6735633517f1338df340e85fc33f.png";